import angular from 'angular'

import findCssRules from './find-css-rules'

import { map, uniqueId, toString, camelCase } from 'lodash-es'

angular
  .module('ggs.utils')
  .factory('ForceHover', ForceHoverFactory)

function ForceHoverFactory(domh, addIdPrefix) {
  return function ForceHover(selector) {
    const id = uniqueId(addIdPrefix(`force-hover-${camelCase(toString(selector))}_`))
    const style = domh.createStyle(id)

    const forceHover = {
      apply,
      clear,
      destroy
    }

    return forceHover

    function apply() {
      const rules = findCssRules(selector)
      const origText = map(rules, 'cssText').join('\n')
      const forceText = domh.addRootQs(origText.replace(/:hover/g, ''))
      style.attach().local.important(forceText)
      return forceHover
    }

    function clear() {
      style.clear()
      return forceHover
    }

    function destroy() {
      style.detach()
      return forceHover
    }
  }
}
